module.exports = __webpack_public_path__ + "static/media/hopper.e4e79dc8.glb";